module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "accept-invitation"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "Lewis Rice",
      "src": require("../assets/images/lewis-rice-logo-white.svg")
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Estate Planning Document Portal")]), _vm._v(" "), (_vm.checkComplete) ? _c('div', [_c('h2', [_vm._v("Welcome!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-default",
    on: {
      "click": function($event) {
        return _vm.goSetPassword()
      }
    }
  }, [_vm._v("Continue")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("It looks like this is your first time here."), _c('br'), _vm._v("Let's complete your account setup.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79cbd5ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AcceptInvitation.vue
// module id = 284
// module chunks = 1